import React, { useState } from "react";
import Loading from "./components/loading/loading.js";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import api from "./api.js";
import { useForm, FormProvider } from "react-hook-form";
import StepDadosCliente from "./components/steps/stepDadosCliente";
import StepDadosContrato from "./components/steps/stepDadosContrato";
import StepPossuiContrato from "./components/steps/stepPossuiContrato";
import StepIndicator from "./components/stepIndicator";
import { useNavigate } from "react-router-dom";
import styles from "./styles/stepForm.module.css";
import useIsMobile from "./hooks/useIsMobile";

const stringSteps = [
  "Dados do cliente",
  "Possui o contrato?",
  "Dados do contrato",
];
const steps = [
  <StepDadosCliente />,
  <StepPossuiContrato />,
  <StepDadosContrato />,
];

const StepForm = () => {
  const [step, setStep] = useState(0);

  const navigate = useNavigate();
  const isMobile = useIsMobile();

  const irParaNaoTenhoContrato = () => {
    navigate("/naoTenhoContrato");
  };

  const methods = useForm({
    mode: "onBlur",
    defaultValues: {
      nome: "",
      sobrenome: "",
      celular: "",
      email: "",
      dataNascimento: "",
      dataContrato: "",
      quantidadeTotalParcelas: 0,
      quantidadeParcelasPagas: 0,
      valorUltimaParcelaPaga: 0,
      motivoDistrato: "0",
      usaOuConstruiuNoImovel: false,
    },
  });

  const next = async () => {
    const valid = await methods.trigger();
    if (valid) setStep((s) => s + 1);
  };

  const prev = () => setStep((s) => s - 1);

  const onSubmit = async (data) => {
    Loading.show("Aguarde....");
    var resultadoApi;
    var retornoApi;
    resultadoApi = api
      .post("/finalizarCalculoDistrato/", JSON.stringify(data), {
        crossdomain: true,
      })
      .then(function (AxiosResponse) {
        if (AxiosResponse.data.SUCCESS) {
          retornoApi = AxiosResponse.data;
          Loading.hide();

          // Leva para a próxima página com os dados da resposta
          navigate("/resultadoCalculo", { state: { retornoApi } });
        } else {
          Loading.hide();
          toastr.error("Erro!", AxiosResponse.data);
        }
      })
      .catch((e) => {
        Loading.hide();
        toastr.error("Erro!", e);
      }).finally;
  };

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)}>
        {/* Logotipo no topo */}
        <div className="logo-topo">
          <img src="../img/iconwp.png" alt="Logo" width="120px" />
        </div>
        <div className={`container-fluid ${styles.telaCentralStepForm}`}>
          {/* Conteúdo da etapa  classname=conteudo-stepForm*/}
          <div className={`${styles.conteudo}`}>
            {/* Indicador de passos */}
            <StepIndicator steps={stringSteps} currentStep={step + 1} />
            {steps[step]}

            {/* Botões de navegação */}
            <div className="text-center">
              {step > 0 && (
                <button
                  type="button"
                  className={`btn btn-secondary ${
                    isMobile ? "text-nowrap" : "text-nowrap me-3"
                  } borda-botao`}
                  style={step == 1 ? { width: "400px" } : {}}
                  onClick={step == 1 ? irParaNaoTenhoContrato : prev}
                >
                  {step == 2 ? "Voltar" : "Não estou com o contrato."}
                </button>
              )}
              {step < steps.length - 1 ? (
                <button
                  type="button"
                  className={`btn btn-primary text-nowrap borda-botao ${
                    isMobile ? "" : "ms-3"
                  } `}
                  style={step == 1 ? { width: "400px" } : {}}
                  onClick={next}
                >
                  {step == 0 ? "Próximo" : "Sim, tenho!"}
                </button>
              ) : (
                <button
                  type="submit"
                  className={`btn btn-primary borda-botao ${
                    isMobile ? "" : "ms-3"
                  }`}
                >
                  Concluir
                </button>
              )}
            </div>
          </div>

          {/* Elementos decorativos */}
          <div className="quadrado-preto" />
          <div className="quadrado-listrado" />
          <div className="quadrado-listrado-preto" />
        </div>
      </form>
    </FormProvider>
  );
};

export default StepForm;
